/**
 *  Author: shaochuan.he
 *  Date: 2016-12-13
 *  分享
 */

let Share = require('@dp/util-m-share');
export default function(config, suc) {
    config = config || {};

    // 分享初始化
    let share = new Share({
        title: config.title,
        desc: config.desc,
        url: config.url,
        image: config.image,
        content: config.content,
        channelDPApp: [Share.CHANNEL.WECHAT_FRIENDS,Share.CHANNEL.WECHAT_TIMELINE],
        channelWX: [Share.CHANNEL.WECHAT_FRIENDS,Share.CHANNEL.WECHAT_TIMELINE],
        channelBrowser: [Share.CHANNEL.WEIBO,Share.CHANNEL.WEIBO_TECENT],
        channelQQ: [Share.CHANNEL.WECHAT_FRIENDS],
        handle: function(){},
        success: function(){
            console.log('share success');
            suc && suc();
        },
        fail: function(){console.log('share failed');},
        cancel: function(){console.log('share canceled');}
    },{
        hide: false
    });

    return share;
}


// WEBPACK FOOTER //
// ./src/lib/share.js